import CreateShippingForm from "./CreateShippingForm"
import ShippingPageLayout from "./ShippingPageLayout"

const CreateShippingPage = () => {
  return (
    <ShippingPageLayout>
      <div className="bg-white rounded-xl p-4">
        <CreateShippingForm />
      </div>
    </ShippingPageLayout>
  )
}

export default CreateShippingPage